import { createSlice } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import deleteCookie from "../../../Utils/Cookies/deleteCookie";
import setCookie from "../../../Utils/Cookies/setCookie";
import { NepaliDate } from "@zener/nepali-datepicker-react";

const initialState = {
  isAuthenticated: false,
  loadingLogin: false,
  loadingLogout: false,
  user: null,
  userId: "",
  authError: false,
  isSuperuser: false,
  isSetupDone: true,
  permissions: [],
  loadingResetPassword: false,
  loadingChangePassword: false,
  message: [],
  photo: "",
  changeTransactionStatus: true,
  transactionDate: new NepaliDate(),
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    authError: (state) => {
      storage.removeItem("persist:root");
      deleteCookie("access");
      deleteCookie("refresh");
      state.isAuthenticated = false;
      state.loading = false;
      state.user = null;
      state.authError = true;
      state.isSuperuser = false;
    },
    loginSuccess: (state, action) => {
      // const permissions = action.payload?.permissions;
      // const userPermissions = permissions?.map((permission) => {
      //   return permission?.codeName;
      // });
      setCookie("access", action.payload.access, {
        "max-age": 36000000,
      });
      setCookie("refresh", action.payload.refresh, {
        "max-age": 36000000,
      });
      state.isAuthenticated = true;
      state.user = {
        fullName: action.payload?.fullName,
        username: action.payload?.username,
        email: action.payload?.email,
      };
      state.loadingLogin = false;
      state.authError = false;
      state.isSuperuser = action.payload?.isSuperuser;
      state.changeTransactionStatus = action.payload.changeTransactionStatus
        ? action.payload.changeTransactionStatus
        : true;
      // state.isSetupDone = action.payload?.isSetup;

      // state.permissions = userPermissions;
      // state.photo = action.payload?.user?.userPhoto;
    },
    logoutSuccess: (state, action) => {
      storage.removeItem("persist:root");
      deleteCookie("access");
      deleteCookie("refresh");
      state.isAuthenticated = false;
      state.loadingLogout = false;
      state.user = null;
      state.userId = null;
      state.authError = false;
      state.isSuperuser = false;
      state.permissions = [];
      state.groups = [];
      state.img = null;
    },
    forgetPassword: (state, action) => {
      state.loadingResetPassword = false;
      state.message = action.payload;
      state.authError = false;
    },
    resetPassword: (state, action) => {
      state.authError = false;
      state.loadingResetPassword = false;
    },

    checkSetupSuccess: (state, action) => {
      state.isSetupDone = action.payload.isSetup;
    },

    setTransactionDate: (state, action) => {
      state.transactionDate = action.payload;
    },
  },
});

const { actions, reducer } = authSlice;
export const {
  goToPage,
  authError,
  loginSuccess,
  logoutSuccess,
  forgetPassword,
  resetPassword,
  checkSetupSuccess,
  // setTransactionDate,
} = actions;
export default reducer;
